export default "__VITE_ASSET__DLjUOOqD__"